import React from "react";
import { APP_DOMAIN } from '../../core/utils/config';
import { logoFontStyle } from "../../design-system/brand/logoFont";
import { Container } from "../../design-system";
import { brandColors } from "../../design-system/tokens";

const DashboardHero = () => {
  return (
    <div className="relative overflow-hidden">
      {/* Contained decorative glow — fully clipped by overflow-hidden */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-64 h-64 bg-blue-400/15 dark:bg-blue-500/15 rounded-full blur-[80px]" />
        <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-72 h-72 bg-sky-300/15 dark:bg-sky-400/15 rounded-full blur-[80px]" />
      </div>

      <Container size="7xl" className="pt-6 pb-2 md:pt-10 md:pb-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white mb-4 leading-tight">
            Welcome to{" "}
            <span className={`inline-block pb-1 ${brandColors.gradientText}`} style={logoFontStyle}>
              {APP_DOMAIN}
            </span>
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-slate-600 dark:text-dark-300 max-w-2xl mx-auto leading-relaxed">
            Create a personal website that makes you{" "}
            <span className="italic font-semibold text-slate-800 dark:text-dark-200">
              impossible to ignore.
            </span>
          </p>
        </div>
      </Container>
    </div>
  );
};

export default DashboardHero;
